import { render, staticRenderFns } from "./validateMail.vue?vue&type=template&id=4537166e&scoped=true&"
import script from "./validateMail.vue?vue&type=script&lang=js&"
export * from "./validateMail.vue?vue&type=script&lang=js&"
import style0 from "./validateMail.vue?vue&type=style&index=0&id=4537166e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4537166e",
  null
  
)

export default component.exports